import { render } from 'datocms-structured-text-to-html-string'

export default function renderStructuredText(input: any) {
  const options = {
    renderBlock({ record, adapter: { renderNode } }) {
      return renderNode('figure', {}, renderNode('img', { src: record.url }))
    },
    renderInlineRecord({ record, adapter: { renderNode } }) {
      return renderNode('a', { href: `/blog/${record.slug}` }, record.title)
    },
    renderLinkToRecord({ record, children, adapter: { renderNode } }) {
      return renderNode('a', { href: `/blog/${record.slug}` }, children)
    },
  }
  return render(input, options)
}
